import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface ILoadingContextData {
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

type LoadingProviderProps = {
  children: ReactNode;
};

export const LoadingContext = createContext({} as ILoadingContextData);

export function LoadingProvider({ children }: LoadingProviderProps) {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
}

export const useLoading = () => {
  const context = useContext(LoadingContext);

  if (!context) {
    throw Error('Must be inside a LoadingProvider');
  }

  return context;
};

export type { ILoadingContextData };
